"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _navbarLink = _interopRequireDefault(require("../NavbarLink/navbarLink"));

var _icon = _interopRequireDefault(require("../Icon/icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavbarPopupLink = function NavbarPopupLink(_ref) {
  var children = _ref.children,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      disabled = _ref.disabled,
      withBadge = _ref.withBadge,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      onClick = _ref.onClick;
  return _react.default.createElement(_navbarLink.default, {
    onClick: onClick,
    active: active,
    disabled: disabled,
    withBadge: withBadge,
    loading: loading
  }, children, _react.default.createElement(PopupLinkIcon, null));
};

var PopupLinkIcon = function PopupLinkIcon() {
  return _react.default.createElement(_icon.default, {
    name: _icon.default.EXPAND_MORE,
    tiny: true
  });
};

NavbarPopupLink.propTypes = {
  children: _propTypes.default.node.isRequired,
  active: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  onClick: _propTypes.default.func.isRequired
};
var _default = NavbarPopupLink;
exports.default = _default;
NavbarPopupLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "NavbarPopupLink",
  "props": {
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "loading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};